/**
 * Created by Ning Jiang on 2024-07-09.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {WildNudge} from "../WildNudge";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {WildNudgeIntroSlideShowPage} from "./WildNudgeIntroSlideShowPage";

export class WildNudgeIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000,
            backgroundAlpha : 0.6,
            bulletColor : 0xffffff
        },
        stampColor : 0xFFFFFF,
    };

    stampConfig:StampConfig = {
        xNudge : true,
        volatility : Volatility.HIGH
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    public static INTRO_BACKGROUND = "resources/images/introsplash/SplashBackground.jpg";
    public static INTRO_FEATURE_WILD = "resources/images/introsplash/HotWild.png";
    public static INTRO_FEATURE_WILD_US = "resources/images/introsplash/HotWild_US.png";
    public static INTRO_FEATURE_MID = "resources/images/introsplash/SplashSymbols.jpg";
    public static INTRO_FEATURE_SCATTER = "resources/images/introsplash/HotScatter.png";
    public static INTRO_LOGO = "resources/images/introsplash/Logo.png";
    private bgBlack:PIXI.Sprite;


    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(WildNudgeIntroConfig.INTRO_BACKGROUND, WildNudgeIntroConfig.INTRO_BACKGROUND);
        imgLoader.add(WildNudgeIntroConfig.INTRO_FEATURE_WILD, WildNudgeIntroConfig.INTRO_FEATURE_WILD);
        imgLoader.add(WildNudgeIntroConfig.INTRO_FEATURE_WILD_US, WildNudgeIntroConfig.INTRO_FEATURE_WILD_US);
        imgLoader.add(WildNudgeIntroConfig.INTRO_FEATURE_MID, WildNudgeIntroConfig.INTRO_FEATURE_MID);
        imgLoader.add(WildNudgeIntroConfig.INTRO_FEATURE_SCATTER, WildNudgeIntroConfig.INTRO_FEATURE_SCATTER);
        imgLoader.add(WildNudgeIntroConfig.INTRO_LOGO, WildNudgeIntroConfig.INTRO_LOGO);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onResize() {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        bgBlack.anchor.set(0.5, 0.5);
        bgBlack.tint = 0x000000;
        this.bgBlack = bgBlack;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WildNudgeIntroConfig.INTRO_BACKGROUND));
        bgSprite.anchor.set(0.5, 0.5);

        this.background.addChild(bgBlack);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WildNudgeIntroConfig.INTRO_LOGO));
        logoSprite.anchor.set(0.5);
        logoSprite.scale.set(0.8);
        this.logo.addChild(logoSprite);

        this.pages = [
            new WildNudgeIntroSlideShowPage([
                ImgLoader.getImgTexture(WildNudgeIntroConfig.INTRO_FEATURE_WILD),
                ImgLoader.getImgTexture(WildNudgeIntroConfig.INTRO_FEATURE_MID),
                ImgLoader.getImgTexture(WildNudgeIntroConfig.INTRO_FEATURE_SCATTER)
            ], [0.76, 0.76, 0.76], [false, true, false]),
        ];
        if(WildNudge.api.gameClientConfiguration.isSet) {
            this.updateUSImage();
        } else {
            WildNudge.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.updateUSImage();
            });
        }
    }

    private updateUSImage() {
        if(!WildNudge.api.gameClientConfiguration.showLowProbabilityGfx) {
            if(this.pages[0].children.length > 0) {
                (<PIXI.Sprite>this.pages[0].children[0]).texture = ImgLoader.getImgTexture(WildNudgeIntroConfig.INTRO_FEATURE_WILD_US);
                this.pages[0].children[0].scale.set(0.76);
            }
        }
    }
}